module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/left-giftset_df454f.png";